module.exports = __webpack_public_path__ + "static/media/CCHE-BLACKBOX_Apero_RED.c5c7e142.webp";